import { Routes } from '@angular/router';
import { AuthenticationGuard } from '@softline/auth';
import { openStockPostingGuard } from './guards/open-stock-posting.guard';
import { SOFTLINE_ROUTE_MDC_STOCK_POSTING } from './mdc-stock-posting.shared';
import { ProductDetailsRepository } from './repositories/product-details.repository';
import { StockPostingItemRepository } from './repositories/stock-posting-item.repository';
import { StockPostingRepository } from './repositories/stock-posting.repository';
import { StockRepository } from './repositories/stock.repository';
import { StorageLocationRepository } from './repositories/storage-location.repository';
import { ItemPrefillService } from './services/item-prefill.service';
import { ProductDetailsService } from './services/product-details.service';
import { ScanFlowService } from './services/scan-flow.service';
import { StockPostingItemService } from './services/stock-posting-item.service';
import { StockPostingService } from './services/stock-posting.service';

export const mdcStockPostingRoutes: Routes = [
  {
    path: 'mdc-stock-posting',
    canActivate: [AuthenticationGuard],
    providers: [
      StockPostingRepository,
      StockPostingService,
      ProductDetailsRepository,
      ProductDetailsService,
      StorageLocationRepository,
      StockRepository,
      ScanFlowService,
    ],
    children: [
      {
        path: 'setup/stock',
        loadComponent: () => import('./pages/select-stock/select-stock.page'),
      },
      {
        path: 'setup/stock-symbol',
        loadComponent: () =>
          import('./pages/select-stock-symbol/select-stock-symbol.page'),
      },
      {
        path: '',
        canActivate: [openStockPostingGuard],
        providers: [
          StockPostingItemRepository,
          StockPostingItemService,
          ItemPrefillService,
        ],
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./pages/stock-posting/stock-posting.page'),
          },
          {
            path: 'search',
            loadComponent: () => import('./pages/search-product/search-product.page'),
          },
          {
            path: 'products/:productId',
            loadComponent: () => import('./pages/add-product/add-product.page'),
          },
          {
            path: 'pallets/:palletKey',
            loadComponent: () => import('./pages/pallet/pallet.page'),
          },
          {
            path: 'storage-locations/:storageLocationId',
            loadComponent: () => import('./pages/storage-location/storage-location.page'),
          },
        ],
      },
      { path: '**', redirectTo: SOFTLINE_ROUTE_MDC_STOCK_POSTING },
    ],
  },
];
